<template>
  <div class="level">
    <img :src="LevelData.imgUrl" alt="" 图片 />
    <div class="numbers">
      <span class="big">{{ LevelData.superscript }}/</span
      ><span class="small">{{ LevelData.subscript }}</span>
    </div>
    <div class="progress">
      <el-progress
        v-bind:percentage="LevelData | getPercentage"
        :show-text="false"
        :stroke-width="5"
        define-back-color="#B9C7F7"
        :color="LevelData.color"
      ></el-progress>
    </div>
  </div>
</template>
<script>
export default {
  filters: {
    getPercentage: (data) => {
      // data/100

      return parseInt((data.superscript * 100) / data.subscript);
    },
  },
  props: ["LevelData"],
  data() {
    return {};
  },
};
</script>
<style scoped>
.level {
  width: 100%;
  height: 100%;
  position: relative;
}
img {
  width: 100%;
  height: 100%;
}
.numbers {
  position: absolute;
  top: 90px;
  left: 30px;
  color: #fff;
}
.big {
  font-weight: bold;
  font-size: 13px;
}
.small {
  font-size: 7.5px;
}
.progress {
  position: absolute;
  width: 80px;
  right: 13.75px;
  bottom: 20px;
}
</style>
<style scoped>
@media only screen and (max-width: 1000px) {
  .paypal-main {
    width: calc(100% - 45px);
    padding: 20px 27.5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/level.vue